import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import { OrganizationUserService } from "@propertelligent/client-api";
import UsersRowComponent from "./UsersRowComponent";
import { GetImages } from "../../utils/GetImages";
import { infiniteScrollHook } from "../../hooks/infiniteScrollHook";
import useInfiniteScroll from "react-infinite-scroll-hook";
import EmptyState from "../../newComponents/emptystate";
import CustomInputs from "../common/Inputs";
import RequestBreadcrumb from "../common/RequestBreadcrumb";
import BasicDetailsCard from "./BasicDetails/common/BasicDetailsCard";

const ManageUsers = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [FullyQualifiedSorts, SetFulllyQualifiedSort] = useState(null)

  const loadMoreRecords = () => {
    if (!loading) {
      fetchData(currentPage + 1);
    }
  };

  const {
    rows,
    loading,
    hasMore,
    rowCount,
    fetchData,
    currentSortDirection,
    handleSort,
    currentPage,
  } = infiniteScrollHook({
    httpFetchDataFn: OrganizationUserService.getApiOrganizationUserOrganizationlist,
    FullyQualifiedFilters: `User.FirstName.ToLower().Contains("${searchValue.toLowerCase()}")or User.LastName.ToLower().Contains("${searchValue.toLowerCase()}")`,
    FullyQualifiedSorts: FullyQualifiedSorts
  });

  const [sentryRef] = useInfiniteScroll({
    loading: loading,
    hasNextPage: hasMore,
    onLoadMore: loadMoreRecords,
    rootMargin: "0px 0px 100px 0px",
  });

  useEffect(() => {
    SetFulllyQualifiedSort('User.FirstName ' + currentSortDirection)
  }, [currentSortDirection])

  return (
    <>
      <div className="position-relative" id="manageUsers">
        <div
        className="">
          <RequestBreadcrumb
            firstName={"Dashboard"}
            link={"/"}
            currentStep={"Manage Users"}
          />
          <div className="organization_card_container">
            <BasicDetailsCard />
          </div>
          <div className="tenantsTopBar" style={{ padding: "16px 24px 24px 24px" }}>
            <div>
              <p className="top_header black">{rowCount} Users</p>
            </div>

            <div className="rightSideButtonsTenant">
              <div className="searchInputContainer">
                <img src={GetImages.Search} />
                <CustomInputs
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="Search by User Name"
                  id="customInputBorder"
                />
              </div>

              <div>
                <Button
                  onClick={(e) => {
                    navigate("create");
                  }}
                  className="inviteButton sub_text fw-600"
                >
                  Add Users
                </Button>
              </div>
            </div>
          </div>
          <div className="subTopBar1">
            <div className="subTopBarComponents" onClick={handleSort}>
              <img src={GetImages.sort} />
              <p className="normal_text">
                {currentSortDirection === "asc"
                  ? "Sort by: A-Z"
                  : "Sort by: Z-A"}
              </p>
            </div>
          </div>
        </div>

        {rows?.length == 0 && !loading ? (
          <EmptyState
            heading={"No Users found"}
            isButton={false}
            icon={GetImages.NoTenantFound}
            isBorder={false}
          />
        ) : (
          <div
            style={{
              marginTop: "315px",
              zIndex: "102",
              position: "absolute",
              width: "calc(100vw - 290px)",
            }}
          >
            <div
              className="tenantListContainer d-flex flex-column gap-2"
              style={{ height: "calc(100vh - 368px)" }}
            >
              <UsersRowComponent
                rows={rows}
                loading={loading}
                fetchData={fetchData}
                sentryRef={sentryRef}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ManageUsers;
